export const NAMESPACE = 'biometric-authentication';
